<template>
  <modal
    id="create-collection-modal"
    @close="closeModal"
    :show.sync="$parent.modals.createCollection"
    size="sm"
  >
    <div slot="header">
      <h6 class="modal-title" id="modal-title-default">Create Collection</h6>
    </div>

    <div>
      <base-input
        label="Name"
        type="text"
        :placeholder="'Enter a collection name'"
        v-model="newCollection.name"
        maxlength="36"
        required
        spellcheck="false"
      ></base-input>
      <div class="public-toggle d-flex">
        <div>
          <label class="form-control-label">Public</label>
        </div>
        <div>
          <base-switch class="ml-5" v-model="newCollection.is_public"></base-switch>
        </div>
      </div>
      <span
        class="helper-text"
      >If a collection is public, you can share a link to the collection to allow others to view it.</span>
    </div>
    <div v-if="createCollectionError" class="error-message">{{createCollectionError}}</div>
    <base-button
      @click="createCollection"
      :loading="createLoading"
      :disabled="!newCollection.name || created"
      type="primary"
      block
      class="mt-3"
    >{{buttonText}}</base-button>
  </modal>
</template>

<script>
import { mapState } from "vuex";

const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "create-collection",
  data() {
    return {
      createLoading: false,
      createCollectionError: null,
      newCollection: {
        name: "",
        is_public: false
      },
      created: false
    };
  },
  computed: {
    ...mapState(["user"]),
    buttonText() {
      if (this.createLoading) {
        return "CREATING";
      } else if (this.created) {
        return "CREATED 👍";
      } else {
        return "CREATE";
      }
    }
  },
  methods: {
    createCollection() {
      this.createLoading = true;
      this.axios
        .request({
          url: `${apiBaseURL}/api/artv1.1/user/createcollection`,
          method: "post",
          data: {
            name: this.newCollection.name,
            is_public: this.newCollection.is_public ? 1 : 0
          }
        })
        .then(result => {
          if (
            result.data.data.message === "Success" &&
            !result.data.data.api_action_error
          ) {
            this.$store.dispatch("getCollections");
            this.created = true;
            setTimeout(() => this.closeModal(), 1000);
          } else if (result.data.data.api_action_error) {
            this.createCollectionError = result.data.data.api_action_error;
          }
        })
        .catch(error => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        })
        .finally(() => {
          this.createLoading = false;
          this.newCollection.name = "";
          this.newCollection.is_public = false;
        });
    },
    closeModal() {
      this.createLoading = false;
      this.newCollection.name = "";
      this.newCollection.is_public = false;
      this.createFormError = "";
      this.created = false;
      this.createCollectionError = "";
      this.$store.commit("showCreateCollectionModal", false);
    }
  }
};
</script>

<style lang="scss">
#create-collection-modal {
  .error-message {
    color: red;
    font-size: 0.875rem;
    text-align: center;
    margin-top: 0.75rem;
  }

  .helper-text {
    font-size: 0.7rem;
    line-height: 1.7;
    display: block;
  }
}
</style>
